import { CompanyApi } from '@ClientApi/company';
import { ICompanyModel, IUserModel } from '@Shared/models';

export async function signupForEmburseCards(company: ICompanyModel, user: IUserModel) {
  const connections = await CompanyApi.getCompanyGatewayConnections(company.id);

  //Check if company is created in Gateway to apply for Emburse Cards
  //Connections could return an array with null value hence checking for length and null value
  if (connections.length === 0 || (connections.length === 1 && connections[0] === null)) {
    await CompanyApi.signupForEmburseCards(company, user);
  }
}

export function redirectToEmburse(companyId: string) {
  const path = "/";
  const queryParams = `path=${path}&company_id=${companyId}`;
  const windowFeatures = 'top=80,left=80,width=900,height=650';

  window.open(`/go-to-emburse?${queryParams}`, 'popup', windowFeatures);
}
